import FormattedText from './FormattedText';
import React from 'react';
import { MdEdit } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import StatusBadge from '../../ReusableComponents/StatusBadge';
import { usePortalQuery } from '../hooks';
import { ErrorNotice, Loading, Empty } from './Feedback';

export default function FormSummary({ selection, onEdit, allowed }) {
  const query = usePortalQuery(`selecoes/${selection.id}/formulario`);
  const version = query.data?.data;
  const types = {
    text: 'Texto',
    textarea: 'Texto longo',
    email: 'E-mail',
    tel: 'Telefone',
    number: 'Número',
    date: 'Data',
    select: 'Lista',
    radio: 'Escolha única',
    checkbox: 'Confirmação',
    file: 'Arquivo',
  };
  return (
    <section className="card module-card module-content">
      <div className="card-body">
        <div className="portal-admin-row">
          <div className="module-content-heading">
            <h2>Formulário de inscrição</h2>
            <p>Campos compartilhados pelos cargos e versões publicadas.</p>
          </div>
          <DefaultButton
            text="Editar formulário"
            bg="info"
            icon={<MdEdit />}
            disabled={!allowed || !version}
            onClick={onEdit}
          />
        </div>
        <ErrorNotice error={query.error} />
        {query.isLoading ? (
          <Loading />
        ) : (
          version && (
            <>
              <p className="text-muted">
                Versão {version.version} · {version.fields.length + (selection.document_requirements || []).length} campos. Inscrições enviadas
                preservam a versão utilizada na confirmação.
              </p>
              {version.fields.length === 0 && !(selection.document_requirements || []).length && <Empty>Nenhum registro encontrado.</Empty>}
              <div className="portal-form-preview">
                {version.fields.map((field, index) => (
                  <div key={field.id} className="portal-form-preview-field">
                    <div>
                      <strong>
                        {index + 1}. <FormattedText>{field.label}</FormattedText>
                      </strong>
                      <small>
                        {types[field.type] || field.type}
                        <FormattedText>{field.description ? ` · ${field.description}` : ''}</FormattedText>
                      </small>
                    </div>
                    <StatusBadge variant={field.required ? 'info' : 'secondary'}>
                      {field.required ? 'Obrigatório' : 'Opcional'}
                    </StatusBadge>
                  </div>
                ))}
              </div>
              {(selection.document_requirements || []).map((document) => (
                <div key={document.id} className="portal-form-preview-field">
                  <div><strong><FormattedText>{document.title}</FormattedText></strong><small>Arquivo · Documentos exigidos</small></div>
                  <StatusBadge variant={document.required ? 'info' : 'secondary'}>{document.required ? 'Obrigatório' : 'Opcional'}</StatusBadge>
                </div>
              ))}
            </>
          )
        )}
      </div>
    </section>
  );
}
